// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"7d01225e","232":"4f79ec02"}[chunkId] + ".chunk.css";
};